export enum MainTabEnum {
  general = "general",
  message = "message",
  orders = "orders",
  refunds = "refunds",
}
